import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetViolationModel } from "@core/model/query-model-violation";
import { violationFormDefault } from "./form.default";
import { ViolationFormSchema } from "./form.rule";

export const useFormDefaultViolation = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetViolationModel | undefined) => {
    return !cachedValue
      ? violationFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as ViolationFormSchema);
  };

  return {
    getDefault,
  };
};
